import {StyleSheet, PixelRatio} from 'react-native';
import {NAVBAR_HEIGHT, getScreenSize, scale} from "../../../../common/utils";

export default StyleSheet.create({
    searchBoxFix:{
        position: 'absolute',
        top: NAVBAR_HEIGHT,
        width: getScreenSize().width,
        height: getScreenSize().height,
        backgroundColor: 'rgba(0,0,0, .4)',
        zIndex: 100,
        overflow:'hidden'
    },
    searchBoxFixContainer:{
        position: 'absolute',
        width: '100%',
        backgroundColor: '#f7f8fa',
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        paddingBottom: 8,
        top: -262,
    },
    searchBoxWrapper:{
        marginHorizontal: scale(8),
        marginTop: scale(10),
        height: scale(244),
        borderRadius: 16,
        overflow: 'hidden',
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowRadius: 8,
        shadowColor: "rgba(0,0,0,0.06)",
        elevation: 8,
    },
    noShadow:{
        shadowOffset: {
            width: 0,
            height: 0
        },
        shadowRadius: 0,
        shadowColor: "rgba(0,0,0,0)"
    },
    searchBoxMainContainer:{
        paddingTop: scale(16),
        marginTop: scale(-16),
        borderTopRightRadius: 12,
        borderTopLeftRadius: 12,
        paddingHorizontal:24,
        backgroundColor: '#ffffff',
        flex: 1
    },
    searchPlaceBoxWrapper:{
        height: scale(56)
    },

    searchFilterBox:{
        height: scale(56),
        flexDirection: 'row',
        justifyContent:'space-between',
        alignItems: 'center'
    },
    searchFilterText:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: 18,
        color: "#212121",
        marginRight:scale(10),
        flex: 1
    },
    searchFilterIcon:{
        width: scale(18),
        alignSelf:'center',
    },
    searchButton:{
        borderRadius: scale(24),
        height: scale(48),
        marginTop: scale(8),
        zIndex: 99,
        top: 0,
        width:'100%',
        alignItems:'center',
        justifyContent: 'center'
    },
    shadowButton:{
        height: scale(65),
        width: '100%',
        position: 'absolute',
        top: scale(2)
    },
    searchButtonText:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: scale(18),
        zIndex: 20,
        color: "#FFFFFF",
        textAlign: "center",
    }
});